// extracted by mini-css-extract-plugin
export default {"symbolTabList":"SymbolTabs_symbolTabList__Ladan"};